import { render, staticRenderFns } from "./myitem.vue?vue&type=template&id=7254a269&scoped=true&"
import script from "./myitem.vue?vue&type=script&lang=js&"
export * from "./myitem.vue?vue&type=script&lang=js&"
import style0 from "./myitem.vue?vue&type=style&index=0&id=7254a269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7254a269",
  null
  
)

export default component.exports